<template>
  <div :style="themePageStyle">
    <body :data-sidebar="darkMode ? 'dark' : 'light'">
    <div class="vcp-root">
      <div class="vcp-card">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-warning"></div>
        </div>
        <div v-else-if="error" class="text-center py-4">
          <i class="mdi mdi-alert-circle-outline" style="font-size:48px;color:#FF6B6B;"></i>
          <div style="color:var(--fm-h,#F5F0E8);font-size:16px;margin-top:12px;font-weight:600;">Cannot load consultation</div>
          <div style="color:var(--fm-m,#A09888);font-size:13px;margin-top:6px;">{{ error }}</div>
        </div>
        <div v-else-if="consultation">
          <div class="vcp-header">
            <div class="vcp-logo"><i class="mdi mdi-stethoscope" style="color:#BFA164;font-size:28px;"></i></div>
            <div>
              <div class="vcp-title">Pay Vet Consultation</div>
              <div class="vcp-subtitle">Ref {{ consultation.consultation_ref }}</div>
            </div>
          </div>

          <div v-if="consultation.payment_status === 'paid'" class="vcp-paid">
            <i class="mdi mdi-check-decagram" style="font-size:42px;color:#50C878;"></i>
            <div style="font-size:16px;color:#50C878;font-weight:700;margin-top:8px;">Already paid</div>
            <div style="font-size:12px;color:var(--fm-m,#A09888);margin-top:4px;">Thank you — no further action needed.</div>
          </div>

          <div v-else>
            <div class="vcp-summary">
              <div class="vcp-row"><span>Vet</span><strong>{{ consultation.vet_name }}</strong></div>
              <div class="vcp-row" v-if="consultation.animal_name || consultation.animal_tag"><span>Animal</span><strong>{{ consultation.animal_name || consultation.animal_tag }}</strong></div>
              <div class="vcp-row" v-if="consultation.farm_name"><span>Farm</span><strong>{{ consultation.farm_name }}</strong></div>
              <div class="vcp-row" v-if="consultation.reason"><span>Reason</span><strong>{{ consultation.reason }}</strong></div>
              <div class="vcp-row" v-if="consultation.scheduled_date"><span>Date</span><strong>{{ consultation.scheduled_date }}</strong></div>
              <div class="vcp-row vcp-fee"><span>Amount due</span><strong>KES {{ Number(consultation.total_charge || consultation.fee || 0).toLocaleString() }}</strong></div>
            </div>

            <div v-if="!pushed" class="vcp-pay-form">
              <label class="vcp-label">M-Pesa phone</label>
              <input v-model="phone" class="vcp-input" placeholder="0712 345 678" type="tel" inputmode="tel" />
              <small style="color:var(--fm-s,#6B6356);font-size:11px;display:block;margin-top:4px;">Default is the number on file. Override to pay from a different M-Pesa line.</small>
              <button class="btn btn-warning w-100 mt-3" @click="initiatePay" :disabled="!phone || paying">
                <span v-if="paying"><span class="spinner-border spinner-border-sm me-1"></span>Sending prompt…</span>
                <span v-else><i class="mdi mdi-cellphone-arrow-down me-1"></i>Pay with M-Pesa</span>
              </button>
              <div v-if="payError" class="vcp-error">{{ payError }}</div>
            </div>

            <div v-else class="vcp-pushed">
              <i class="mdi mdi-cellphone-message" style="font-size:42px;color:#BFA164;"></i>
              <div style="font-size:15px;color:var(--fm-h,#F5F0E8);font-weight:600;margin-top:10px;">Check your phone</div>
              <div style="font-size:12px;color:var(--fm-m,#A09888);margin-top:4px;line-height:1.5;">
                An M-Pesa prompt was sent to <strong>{{ pushedPhone }}</strong>. Enter your M-Pesa PIN to pay.
                <br/>If you didn't receive it, wait 10 seconds and try again.
              </div>
              <button class="btn btn-link mt-2" @click="reset" style="color:#BFA164;">Use a different phone</button>
              <div v-if="polling" style="font-size:11px;color:var(--fm-s,#6B6356);margin-top:6px;">
                <span class="spinner-border spinner-border-sm me-1"></span>Waiting for payment confirmation…
              </div>
            </div>
          </div>

          <div class="vcp-footer">
            <i class="mdi mdi-shield-check me-1"></i>Secured by M-Pesa &middot; Flockr Paybill
          </div>
        </div>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "VetConsultPay",
  data() {
    return {
      darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark') !== 'light',
      loading: true,
      error: null,
      consultation: null,
      phone: '',
      paying: false,
      payError: null,
      pushed: false,
      pushedPhone: '',
      polling: false,
      pollTimer: null,
      pollCount: 0
    };
  },
  computed: {
    themePageStyle(){ return this.darkMode ? 'background:#0A0A0A;min-height:100vh;color:#F5F0E8;' : 'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'; }
  },
  mounted() { this.load(); },
  beforeUnmount() { if (this.pollTimer) clearTimeout(this.pollTimer); },
  methods: {
    async load() {
      var ref = this.$route.params.ref;
      if (!ref) { this.error = 'Missing consultation reference'; this.loading = false; return; }
      try {
        var r = await executeJson({ function: 'getConsultationByRef', consultationRef: ref }, flocker);
        if (r.data && r.data.success) {
          this.consultation = r.data.data.consultation;
          // Default the phone field to the farmer's saved phone (full, not masked)
          this.phone = this.consultation.farmer_phone || '';
        } else {
          this.error = (r.data && r.data.message) || 'Consultation not found';
        }
      } catch (e) { this.error = 'Network error — please try again'; }
      this.loading = false;
    },
    async initiatePay() {
      this.paying = true;
      this.payError = null;
      try {
        var r = await executeJson({ function: 'payConsultation', consultationRef: this.consultation.consultation_ref, phone: this.phone }, flocker);
        if (r.data && r.data.success) {
          this.pushed = true;
          this.pushedPhone = r.data.data && r.data.data.phone ? r.data.data.phone : this.phone;
          this.startPolling();
        } else {
          this.payError = (r.data && r.data.message) || 'Could not start payment';
        }
      } catch (e) { this.payError = 'Network error'; }
      this.paying = false;
    },
    reset() {
      this.pushed = false;
      this.polling = false;
      if (this.pollTimer) { clearTimeout(this.pollTimer); this.pollTimer = null; }
    },
    startPolling() {
      this.polling = true;
      this.pollCount = 0;
      this.pollPaymentStatus();
    },
    async pollPaymentStatus() {
      if (this.pollCount > 30) { this.polling = false; return; } // ~2.5 min cap
      this.pollCount++;
      try {
        var r = await executeJson({ function: 'getConsultationByRef', consultationRef: this.consultation.consultation_ref }, flocker);
        if (r.data && r.data.success && r.data.data.consultation.payment_status === 'paid') {
          this.consultation.payment_status = 'paid';
          this.polling = false;
          if (this.pollTimer) { clearTimeout(this.pollTimer); this.pollTimer = null; }
          return;
        }
      } catch (e) { /* keep polling */ }
      var self = this;
      this.pollTimer = setTimeout(function(){ self.pollPaymentStatus(); }, 5000);
    }
  }
};
</script>

<style scoped>
.vcp-root{min-height:100vh;display:flex;align-items:flex-start;justify-content:center;padding:24px 16px;}
.vcp-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:24px;width:100%;max-width:480px;box-shadow:0 8px 32px rgba(0,0,0,.25);}
html[data-theme="light"] .vcp-card{background:#FFFFFF;border-color:#E8E2DA;}
.vcp-header{display:flex;align-items:center;gap:12px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid var(--fm-br,#2A2520);}
.vcp-logo{width:48px;height:48px;border-radius:50%;background:rgba(191,161,100,.12);display:flex;align-items:center;justify-content:center;}
.vcp-title{font-size:18px;font-weight:700;color:var(--fm-h,#F5F0E8);}
.vcp-subtitle{font-size:12px;color:var(--fm-m,#A09888);margin-top:2px;}
.vcp-summary{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:14px;margin-bottom:16px;}
html[data-theme="light"] .vcp-summary{background:#F7F5F2;border-color:#E8E2DA;}
.vcp-row{display:flex;justify-content:space-between;gap:12px;padding:6px 0;font-size:13px;}
.vcp-row span{color:var(--fm-m,#A09888);}
.vcp-row strong{color:var(--fm-h,#F5F0E8);text-align:right;}
.vcp-fee{border-top:1px solid var(--fm-br,#2A2520);padding-top:10px;margin-top:6px;font-size:15px;}
.vcp-fee strong{color:#BFA164;font-size:16px;}
.vcp-label{display:block;font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:.4px;margin-bottom:4px;}
.vcp-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:6px;padding:10px 12px;font-size:15px;width:100%;}
html[data-theme="light"] .vcp-input{background:#F7F5F2;border-color:#E0D8D0;color:#1A1A1A;}
.vcp-error{margin-top:10px;padding:8px 12px;background:rgba(255,107,107,.08);border:1px solid rgba(255,107,107,.3);border-radius:6px;font-size:12px;color:#FF6B6B;}
.vcp-pushed{text-align:center;padding:24px 8px;}
.vcp-paid{text-align:center;padding:32px 16px;}
.vcp-footer{margin-top:20px;padding-top:14px;border-top:1px solid var(--fm-br,#1E1E1E);text-align:center;font-size:11px;color:var(--fm-s,#6B6356);}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .vcp-container { padding-top: 60px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .vcp-card { padding: 14px !important; border-radius: 10px !important; }
  .vcp-error { font-size: 11px; padding: 6px 10px; }
}
</style>
